
export default function Benifits() {
    return (
        <>
            <div class="Home_fixmid__2p61M">
                <div class="Home_projecthead__3QK6I">
                    <div class="Home_headingtitle__1Pp9y">
                        <h2>Our
                            <span>
                                 Process</span>
                            - Your <span>Benefit</span>
                        </h2>
                    </div>
                </div>
                <div class="Home_processcover__2Rc7Z aos-init aos-animate"
                    data-aos="fade-up">
                    <div class="row">
                        <div class="Home_processorder__ssXrW col-lg-3 col-md-3 col-sm-12">
                            <div class="Home_processlists__3AGVg">
                                <div class="homeProcessDiv">
                                    <div class="homeProcessDiv2">
                                        <img alt="" aria-hidden="true" role="presentation"
                                            src="images/submitReqimage.webp"
                                            class="homeProcessImg" />
                                    </div>
                                    {/* <img
                                        alt="icon"
                                        src="/_next/image?url=%2Fimages%2Ficons_36.png&amp;w=256&amp;q=75"
                                        srcset="/_next/image?url=%2Fimages%2Ficons_36.png&amp;w=96&amp;q=75 1x, /_next/image?url=%2Fimages%2Ficons_36.png&amp;w=256&amp;q=75 2x"
                                        decoding="async"
                                        style="visibility: inherit; position: absolute; inset: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;" /> */}
                                </div>
                                <h5>
                                    Submit your requirement</h5><p>And our technical experts will understand your requirement &amp; have a free consultation about your home construction</p>
                                <h3>
                                    0
                                    <span>
                                        1
                                    </span>
                                </h3>
                            </div>
                        </div>
                        <div class="Home_processorder__ssXrW col-lg-3 col-md-3 col-sm-12">
                            <div class="Home_processlists__3AGVg">
                                <div
                                    class="homeProcessBorder">
                                    <div class="homeProcessBorderDiv">
                                        <img alt="" aria-hidden="true" role="presentation"
                                            src="images/FillUpReqimage.webp"
                                            class="homeProcessBorderImg" />
                                    </div>
                                    {/* <img
                                        alt="icon"
                                        src="/_next/image?url=%2Fimages%2Ficons_38.png&amp;w=256&amp;q=75" srcset="/_next/image?url=%2Fimages%2Ficons_38.png&amp;w=96&amp;q=75 1x, /_next/image?url=%2Fimages%2Ficons_38.png&amp;w=256&amp;q=75 2x" decoding="async"
                                        style="visibility: inherit; position: absolute; inset: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;" /> */}
                                </div>
                                <h5>
                                    Fill up the requirement on the Google form</h5>
                                <p>&amp; have Interaction with Architect for detailed discussion on the building design
                                </p>
                                <h3>
                                    0
                                    <span>
                                        2
                                    </span>
                                </h3>
                            </div>
                        </div>
                        <div class="Home_processorder__ssXrW col-lg-3 col-md-3 col-sm-12"><div class="Home_processlists__3AGVg">
                            <div class="homeProcessBox">
                                <div
                                    class="homeProcessBoxDiv">
                                    <img alt="" aria-hidden="true" role="presentation"
                                        src="images/AgreementReqimage.webp"
                                        class="homeProcessBoxImg" />
                                </div>
                                {/* <img alt="icon"
                                    src="/_next/image?url=%2Fimages%2Ficons_40.png&amp;w=256&amp;q=75"
                                    srcset="/_next/image?url=%2Fimages%2Ficons_40.png&amp;w=96&amp;q=75 1x, /_next/image?url=%2Fimages%2Ficons_40.png&amp;w=256&amp;q=75 2x" decoding="async"
                                    style="visibility: inherit; position: absolute; inset: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;" /> */}
                            </div>
                            <h5>Agreement signing between clients &amp; buildAhome</h5>
                            <p>We assist to get the Plan sanctioned by Govt. approval bodies</p>
                            <h3>0<span>3</span>
                            </h3>
                        </div>
                        </div>
                        <div class="Home_processorder__ssXrW col-lg-3 col-md-3 col-sm-12">
                            <div class="Home_processlists__3AGVg">
                                <div
                                    class="homeProcessList">
                                    <div class="homeProcessListDiv">
                                        <img alt="" aria-hidden="true" role="presentation"
                                            src="images/constructionStepimage.webp"
                                            class="homeProcessListImg" />
                                    </div>
                                    {/* <img alt="icon"
                                        src="/_next/image?url=%2Fimages%2Ficons_42.png&amp;w=256&amp;q=75"
                                        srcset="/_next/image?url=%2Fimages%2Ficons_42.png&amp;w=96&amp;q=75 1x, /_next/image?url=%2Fimages%2Ficons_42.png&amp;w=256&amp;q=75 2x"
                                        decoding="async"
                                        style="visibility: inherit; position: absolute; inset: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;" /> */}
                                </div>
                                <h5>From the initial kick-off till each construction step</h5>
                                <p>There will be Site Engineer on site </p>
                                <h3>0<span>4</span>
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div class="Home_processbtncovers__Di5Dj"><a href="/how-it-works" class="Home_readmore__4Ho5B"><span>Know More</span
                ></a>
                </div> */}
            </div>
        </>
    )
}